// extracted by css-extract-rspack-plugin
export default {"submittedFeedbackButton":"Feedback-module__submittedFeedbackButton__N4O9O"};